import React, { useState } from "react";
import "./document-modal.scss";

const DocumentModal = ({ isOpen, onClose }) => {
  const documents = [
    {
      id: 1,
      name: "Sentencia Agüero - Absolución",
      file: "/sentencia_aguero_absolucion.pdf",
      icon: "📄",
      date: "2024",
      size: "2.5 MB",
    },
    {
      id: 2,
      name: "EscalE - Resumen",
      file: "/escalE.pdf",
      icon: "📄",
      date: "2024",
      size: "1.8 MB",
    },
  ];

  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!isOpen) return null;

  return (
    <div className="document-modal-overlay" onClick={onClose}>
      <div className="document-modal" onClick={(e) => e.stopPropagation()}>
        <div className="document-modal-header">
          <h3>
            <i className="fas fa-file-pdf"></i>
            <span>Documentos Judiciales</span>
          </h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="document-modal-body">
          <div className="document-grid">
            {documents.map((doc) => (
              <div
                key={doc.id}
                className="document-card"
                onClick={() => window.open(doc.file, "_blank")}
              >
                <div className="document-icon">
                  <i className="fas fa-file-pdf pdf-icon"></i>
                </div>
                <div className="document-info">
                  <h4 className="document-name">{doc.name}</h4>
                  <div className="document-meta">
                    <span className="document-date">
                      <i className="fas fa-calendar"></i>
                      {doc.date}
                    </span>
                    <span className="document-size">
                      <i className="fas fa-hdd"></i>
                      {doc.size}
                    </span>
                  </div>
                </div>
                <div className="document-actions">
                  <button
                    className="action-btn preview-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(doc.file, "_blank");
                    }}
                    title="Vista previa"
                  >
                    <i className="fas fa-eye"></i>
                  </button>
                  <button
                    className="action-btn download-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownload(doc.file, doc.name + ".pdf");
                    }}
                    title="Descargar"
                  >
                    <i className="fas fa-download"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="document-modal-footer">
          <button className="btn-close-modal" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
